/**
 * ============================================================================
 * main.js - Entry Point dell'Applicazione
 * ============================================================================
 * 
 * Punto di ingresso principale dell'applicazione Vue CRF.
 * Inizializza l'app Vue e monta il componente root sul DOM.
 * 
 * SETUP:
 * • Importa componente App principale
 * • Carica stili globali SCSS
 * • Crea istanza Vue e monta su #app
 * 
 * ============================================================================
 */

import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/main.scss'

createApp(App).mount('#app')
